module.exports = __webpack_public_path__ + "static/main-banner_pinkblue_24_11zon-f21b735eea23a47117b1a6d94b7f3770.webp";